import { HeaderMenus as HeaderMenusJP } from './header';
import { FooterMenu as FooterMenuJP, FooterCopyRightLinks as FooterCopyRightLinksJP } from './footer';
import { GlobalNavigationConfig } from '../../../entities';

export const JapanConfig: GlobalNavigationConfig = {
  footerVariant: 'simple',
  headerVariant: 'simple',
  logoVariant: 'japan',
  menu: {
    copyright: FooterCopyRightLinksJP,
    footer: FooterMenuJP,
    header: HeaderMenusJP,
  },
};
